import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const TelekFlow = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useState({
    location: '',
    type: 'plot',
    budget: '',
    purpose: ''
  });

  const mockPlots = [
    {
      id: 1,
      location: 'Budapest, XIII. kerület',
      size: '600 m²',
      price: '45.000.000 Ft',
      utilities: 'Víz, villany, gáz',
      image: '🏞️',
      buildable: '180 m² ház építhető'
    },
    {
      id: 2,
      location: 'Budaörs',
      size: '800 m²',
      price: '52.000.000 Ft',
      utilities: 'Víz, villany',
      image: '🌳',
      buildable: '240 m² ház építhető'
    },
    {
      id: 3,
      location: 'Szentendre',
      size: '1200 m²',
      price: '38.000.000 Ft',
      utilities: 'Víz',
      image: '🏔️',
      buildable: '360 m² ház építhető'
    }
  ];

  const suggestedHouses = [
    {
      id: 1,
      name: 'Modern családi ház',
      size: '120 m²',
      price: '38.400.000 Ft',
      time: '4 hónap',
      icon: '🏢'
    },
    {
      id: 2,
      name: 'Klasszikus ház',
      size: '150 m²',
      price: '48.000.000 Ft',
      time: '5 hónap',
      icon: '🏛️'
    }
  ];

  return (
    <div className="min-h-screen bg-[#0a0a0a] py-12 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-black text-white mb-4">
            Telek + Ház egyben
          </h1>
          <p className="text-xl text-gray-300">
            Találd meg a telket, és nézd meg mit építhetsz rá
          </p>
        </div>

        {/* Search */}
        <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl rounded-2xl p-6 border-2 border-white/[0.08] mb-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <input
              type="text"
              placeholder="Lokáció"
              value={searchParams.location}
              onChange={(e) => setSearchParams({ ...searchParams, location: e.target.value })}
              className="bg-white/10 border-2 border-white/[0.08] rounded-xl px-4 py-3 text-white placeholder-gray-400 focus:border-blue-500 focus:outline-none"
            />
            <input
              type="text"
              placeholder="Ár (max)"
              value={searchParams.budget}
              onChange={(e) => setSearchParams({ ...searchParams, budget: e.target.value })}
              className="bg-white/10 border-2 border-white/[0.08] rounded-xl px-4 py-3 text-white placeholder-gray-400 focus:border-blue-500 focus:outline-none"
            />
            <select
              value={searchParams.purpose}
              onChange={(e) => setSearchParams({ ...searchParams, purpose: e.target.value })}
              className="bg-white/10 border-2 border-white/[0.08] rounded-xl px-4 py-3 text-white focus:border-blue-500 focus:outline-none"
            >
              <option value="">Cél</option>
              <option value="own">Saját célra</option>
              <option value="investment">Befektetésre</option>
            </select>
          </div>
        </div>

        {/* Plot Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {mockPlots.map((plot) => (
            <div
              key={plot.id}
              className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl rounded-2xl p-6 border-2 border-white/[0.08] hover:border-blue-500 transition-all hover:scale-105"
            >
              {/* Image */}
              <div className="text-6xl text-center mb-4">{plot.image}</div>

              {/* Info */}
              <h3 className="text-xl font-black text-white mb-2">{plot.location}</h3>
              <div className="space-y-2 mb-4">
                <div className="flex justify-between text-sm">
                  <span className="text-gray-400">Méret:</span>
                  <span className="text-white font-bold">{plot.size}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-400">Ár:</span>
                  <span className="text-green-400 font-bold">{plot.price}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-400">Közmű:</span>
                  <span className="text-white">{plot.utilities}</span>
                </div>
              </div>

              {/* Buildable */}
              <div className="bg-blue-500/20 border border-blue-500/30 rounded-xl p-3 mb-4">
                <p className="text-blue-300 text-sm font-bold text-center">
                  🏗️ {plot.buildable}
                </p>
              </div>

              {/* CTA */}
              <button
                onClick={() => {
                  // Show what can be built
                  const modal = document.getElementById('house-suggestions');
                  if (modal) modal.classList.remove('hidden');
                }}
                className="w-full bg-gradient-to-r from-blue-500 to-cyan-600 hover:from-cyan-600 hover:to-blue-500 text-white font-black py-3 rounded-xl transition-all"
              >
                Mit építhetek ide?
              </button>
            </div>
          ))}
        </div>

        {/* House Suggestions Modal (simplified) */}
        <div id="house-suggestions" className="hidden fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80">
          <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0a0a0a] rounded-2xl max-w-3xl w-full p-8 border-2 border-blue-500/30">
            <h2 className="text-3xl font-black text-white mb-6">
              Mit építhetsz erre a telekre?
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              {suggestedHouses.map((house) => (
                <div key={house.id} className="bg-white/10 rounded-xl p-6 border border-white/[0.08]">
                  <div className="text-5xl mb-4 text-center">{house.icon}</div>
                  <h3 className="text-xl font-bold text-white mb-3">{house.name}</h3>
                  <div className="space-y-2 text-sm mb-4">
                    <div className="flex justify-between">
                      <span className="text-gray-400">Méret:</span>
                      <span className="text-white">{house.size}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-400">Építési ár:</span>
                      <span className="text-green-400 font-bold">{house.price}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-400">Időtartam:</span>
                      <span className="text-white">{house.time}</span>
                    </div>
                  </div>
                  <button className="w-full bg-gradient-to-r from-green-500 to-emerald-600 text-white font-bold py-2 rounded-lg">
                    Érdekel
                  </button>
                </div>
              ))}
            </div>

            <button
              onClick={() => document.getElementById('house-suggestions').classList.add('hidden')}
              className="w-full bg-white/10 hover:bg-white/20 text-white font-bold py-3 rounded-xl"
            >
              Bezárás
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TelekFlow;
